import React from 'react';

import { ReactComponent as CrossIcon } from '@/app/_icons/cross.svg';
import { TagWrapper } from '@/old-shared/components/buttons/default-button/components/tag-wrapper/tag-wrapper';
import {
  CarFilter,
  SearchFilter,
  SimpleFilter,
} from '@/types/filters/filters.types';

import styles from './filter-tag.module.scss';

export const FilterTag: React.FC<{
  option: SearchFilter | SimpleFilter | CarFilter;
  handleRemove?: () => void;
}> = ({ option, handleRemove }) => {
  return (
    <div className={styles.filterTag}>
      <TagWrapper label={option.fullName || ''}>
        {handleRemove && <CrossIcon onClick={handleRemove} />}
      </TagWrapper>
    </div>
  );
};
